<mat-form-field appearance="outline" class="header-datepicker" [class.datepicker-open]="picker.opened"
  (click)="picker.open()">
  <mat-date-range-input [rangePicker]="picker" [formGroup]="range" [max]="maxDate" [min]="minDate">
    <input matStartDate formControlName="startDate" readonly>
    <input matEndDate formControlName="endDate" readonly>
  </mat-date-range-input>
  <mat-datepicker-toggle matIconSuffix [for]="picker">
    <svg matDatepickerToggleIcon width="16" height="16" viewBox="0 0 16 16" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6667 1.23077H12.6667V0.615385C12.6667 0.452174 12.5964 0.295649 12.4714 0.180242C12.3464 0.064835 12.1768 0 12 0C11.8232 0 11.6536 0.064835 11.5286 0.180242C11.4036 0.295649 11.3333 0.452174 11.3333 0.615385V1.23077H4.66667V0.615385C4.66667 0.452174 4.59643 0.295649 4.4714 0.180242C4.34638 0.064835 4.17681 0 4 0C3.82319 0 3.65362 0.064835 3.5286 0.180242C3.40357 0.295649 3.33333 0.452174 3.33333 0.615385V1.23077H1.33333C0.979711 1.23077 0.640573 1.36044 0.390524 1.59125C0.140476 1.82207 0 2.13512 0 2.46154V14.7692C0 15.0957 0.140476 15.4087 0.390524 15.6395C0.640573 15.8703 0.979711 16 1.33333 16H14.6667C15.0203 16 15.3594 15.8703 15.6095 15.6395C15.8595 15.4087 16 15.0957 16 14.7692V2.46154C16 2.13512 15.8595 1.82207 15.6095 1.59125C15.3594 1.36044 15.0203 1.23077 14.6667 1.23077ZM3.33333 2.46154V3.07692C3.33333 3.24013 3.40357 3.39666 3.5286 3.51207C3.65362 3.62747 3.82319 3.69231 4 3.69231C4.17681 3.69231 4.34638 3.62747 4.4714 3.51207C4.59643 3.39666 4.66667 3.24013 4.66667 3.07692V2.46154H11.3333V3.07692C11.3333 3.24013 11.4036 3.39666 11.5286 3.51207C11.6536 3.62747 11.8232 3.69231 12 3.69231C12.1768 3.69231 12.3464 3.62747 12.4714 3.51207C12.5964 3.39666 12.6667 3.24013 12.6667 3.07692V2.46154H14.6667V4.92308H1.33333V2.46154H3.33333ZM14.6667 14.7692H1.33333V6.15385H14.6667V14.7692Z"
        fill="currentColor" />
    </svg>
  </mat-datepicker-toggle>
  <span class="range-display">
    {{ selectedRangeValue }}
  </span>
  <img class="arrow" [class.up]="picker.opened" [src]="'svg/sort-arrow.svg' | assetVersion" alt="'icon'">
  <mat-date-range-picker #picker class="custom-date-picker" (closed)="onPickerClose()">
    <mat-date-range-picker-actions>
      <div class="preset-buttons">
        <div class="preset-button"
          [class.active]="isActivePreset(fixedDateRanges.YESTERDAY)"
          (click)="selectPresetDays(1)">{{ fixedDateRanges.YESTERDAY }}</div>
        <div class="preset-button"
          [class.active]="isActivePreset(fixedDateRanges.LAST_7_DAYS)"
          (click)="selectPresetDays(7)">{{ fixedDateRanges.LAST_7_DAYS }}</div>
        <div class="preset-button"
          [class.active]="isActivePreset(fixedDateRanges.LAST_14_DAYS)"
          (click)="selectPresetDays(14)">{{ fixedDateRanges.LAST_14_DAYS }}</div>
        <div class="preset-button"
          [class.active]="isActivePreset(fixedDateRanges.LAST_30_DAYS)"
          (click)="selectPresetDays(30)">{{ fixedDateRanges.LAST_30_DAYS }}</div>
        <div class="preset-button"
          [class.active]="isActivePreset(fixedDateRanges.THIS_MONTH)"
          [class.disabled]="isPresetUnavailable(fixedDateRanges.THIS_MONTH)"
          [matTooltip]="getUnavailablePresetTooltip(fixedDateRanges.THIS_MONTH)"
          matTooltipPosition="right"
          (click)="!isPresetUnavailable(fixedDateRanges.THIS_MONTH) && selectThisMonth()">{{ fixedDateRanges.THIS_MONTH }}</div>
        <div class="preset-button"
          [class.active]="isActivePreset(fixedDateRanges.LAST_MONTH)"
          [class.disabled]="isTrialUser"
          [class.trial-disabled]="isTrialUser"
          (click)="!isTrialUser && selectLastMonth()">
          <span>{{ fixedDateRanges.LAST_MONTH }}</span>
          @if (isTrialUser) {
            <img [src]="'svg/premium-badge.svg' | assetVersion" 
                 alt="Premium" 
                 class="premium-badge"
                 [matTooltip]="'The free trial includes data from the last 30 days.\nThe full plan allows access to longer time ranges.'"
                 matTooltipPosition="right">
          }
        </div>
        <div class="preset-button"
          [class.active]="isActivePreset(fixedDateRanges.THIS_QUARTER)"
          [class.disabled]="isTrialUser || isPresetUnavailable(fixedDateRanges.THIS_QUARTER)"
          [class.trial-disabled]="isTrialUser"
          [matTooltip]="isTrialUser ? '' : getUnavailablePresetTooltip(fixedDateRanges.THIS_QUARTER)"
          matTooltipPosition="right"
          (click)="!isTrialUser && !isPresetUnavailable(fixedDateRanges.THIS_QUARTER) && selectThisQuarter()">
          <span>{{ fixedDateRanges.THIS_QUARTER }}</span>
          @if (isTrialUser) {
            <img [src]="'svg/premium-badge.svg' | assetVersion"
                 alt="Premium"
                 class="premium-badge"
                 [matTooltip]="'The free trial includes data from the last 30 days.\nThe full plan allows access to longer time ranges.'"
                 matTooltipPosition="right">
          }
        </div>
        <div class="preset-button"
          [class.active]="isActivePreset(fixedDateRanges.LAST_QUARTER)"
          [class.disabled]="isTrialUser"
          [class.trial-disabled]="isTrialUser"
          (click)="!isTrialUser && selectLastQuarter()">
          <span>{{ fixedDateRanges.LAST_QUARTER }}</span>
          @if (isTrialUser) {
            <img [src]="'svg/premium-badge.svg' | assetVersion"
                 alt="Premium"
                 class="premium-badge"
                 [matTooltip]="'The free trial includes data from the last 30 days.\nThe full plan allows access to longer time ranges.'"
                 matTooltipPosition="right">
          }
        </div>
        <div class="preset-button" (click)="selectCustomRange()" [class.active]="isActivePreset('custom')">Custom Range</div>
      </div>
      <div class="actions-container">
        <button mat-button matDateRangePickerCancel type="button" (click)="onCancel()">
          Cancel
        </button>
        <button mat-raised-button color="primary" matDateRangePickerApply type="button" (click)="onApply()">
          Apply
        </button>
      </div>
    </mat-date-range-picker-actions>
  </mat-date-range-picker>
</mat-form-field>